import { Table, Row, Col, Card } from "react-bootstrap";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import type {TableSkeletonProps} from  '../../types/index'


const TableSkeleton: React.FC<TableSkeletonProps> = ({ cols = 4, rows = 10 }) => {
    return (
        <Card className="mt-4">
            <Table bordered hover>
                <thead className="bg-light bg-white">
                    <tr>
                        {[...Array(cols)].map((el, i) => {
                            return <th key={i}>
                                <Row>
                                    <Col><Skeleton /></Col>
                                    {/* <Col></Col> */}
                                </Row>
                            </th>
                        })}
                    </tr>
                </thead>
                <tbody>
                    {[...Array(rows)].map((_, rowIndex) => (
                        <tr key={rowIndex} className="bg-light bg-white">
                            {[...Array(cols)].map((_, colIndex) => (
                                <td key={colIndex}><Skeleton /></td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </Table>
        </Card>

    );
}

export default TableSkeleton;
